var Aneox;
(function (Aneox) {
  'use strict';

  var Menu = (function () {

    var menu;

    function Menu() {
      menu = $('#menu');
    }

    Menu.prototype.open = function() {
      $('#page-wrapper').addClass('noscroll');
      menu.fadeIn(500);
    };

    Menu.prototype.close = function() {
      menu.fadeOut(500);
      $('#page-wrapper').removeClass('noscroll');
    };

    Menu.prototype.update = function(sectionId) {
      menu.find('.active').removeClass('active');
      if (sectionId === 'domain-philosophy') {
        sectionId = 'domain-presentation';
      } else if (sectionId === 'savoir-faire-vinification') {
        sectionId = 'savoir-faire-viticulture';
      }
      menu.find('a[router-href=' + sectionId + ']').addClass('active');
    }

    return Menu;
  })();

  Aneox.Menu = Menu;
})(Aneox || (Aneox = {}));